import { fetchStatusCount, 
    fetchCommentTeachers, fetchReviewDetail, updateBackReview, updateReviewContent, submitReviewContent, teacherReplyComment,
    requestDistribute
 } from '@/services/comment'

export default {
    namespaced: true,
    state: {
        countInfo: {
            reviewingCount: 0, // 待批改 ,
            waitModifyCount: 0, // 已打回
            watiAgainReviewCount: 0, // 待重批
        },
        reviewInfo: {},
        commentTeachers: [],
    },
    actions: {
        async updateDistribute({ dispatch, commit }, payload) { // 分配
            const { callback, ...rest } = payload
            await requestDistribute(rest)
            typeof callback === 'function' && callback()
          },
        async getTeachers({ dispatch, commit }, payload) { // 写作批改老师列表
            const content = await fetchCommentTeachers(payload)
            commit('UPDATE_VALUE_STATES', { key: 'commentTeachers', data: content })
          },
        async getCountInfo({ dispatch, commit }, payload) { // 批改详情
            const content = await fetchStatusCount(payload)
            commit('UPDATE_VALUE_STATES', { key: 'countInfo', data: content })
        },
        async getReviewDetail({ dispatch, commit }, payload) {
            const content = await fetchReviewDetail(payload)
            commit('UPDATE_VALUE_STATES', { key: 'reviewInfo', data: content })
        },
        async reBackReview({ dispatch, commit }, payload) {
            const { callback, ...rest } = payload
            await updateBackReview(rest)
            typeof callback === 'function' && callback()
        },
        async saveReviewContent({ dispatch, commit }, payload) {
            const { callback, operationType, ...rest } = payload
            operationType === 'save' ? await updateReviewContent(rest) : await submitReviewContent(rest)
            typeof callback === 'function' && callback()
        },
        async replyComment({ dispatch, commit }, payload) {
            const { callback, ...rest } = payload;
            await teacherReplyComment(rest)
            dispatch("getReviewDetail", payload.oralReviewId)
            typeof callback === 'function' && callback()
        }

    },
    mutations: {
        UPDATE_VALUE_STATES(state, payload) {
            const { key, data } = payload
            state[key] = data
        }

    }

}


// WEBPACK FOOTER //
// ./src/store/modules/comment.js